import {
  type BaseType,
  type Props,
  type ValidatorSync,
  typeMismatchError,
} from "./base";
import * as yup from "yup";

export interface StringType extends BaseType {
  type: "STRING";
  pattern?: string;
  maxLength?: number;
  minLength?: number;
}

export function string(props?: Props<StringType>): StringType {
  return {
    ...props,
    type: "STRING",
  };
}

export const validator: ValidatorSync<StringType> = (type, options) => {
  if (options?.extendedTypesValidationsV2) {
    return handRolledValidator(type);
  }
  return yupValidator(type);
};

const yupValidator = (type: Readonly<StringType>) => {
  let schema = yup.string();

  if (type.pattern) schema = schema.matches(new RegExp(type.pattern));

  if (typeof type.maxLength === "number") schema = schema.max(type.maxLength);
  if (typeof type.minLength === "number") schema = schema.min(type.minLength);

  return (value: unknown) => {
    schema.validateSync(value, { strict: true });
  };
};

const handRolledValidator = (type: Readonly<StringType>) => {
  const pattern = type.pattern ? new RegExp(type.pattern) : undefined;

  return (value: unknown) => {
    const unboxed = value instanceof String ? value.valueOf() : value;
    if (typeof unboxed !== "string") {
      throw typeMismatchError("string", value);
    }

    if (pattern && !pattern.test(unboxed)) {
      throw new Error(`this must match the following: "${pattern}"`);
    }

    if (typeof type.maxLength === "number" && unboxed.length > type.maxLength) {
      throw new Error(`this must be at most ${type.maxLength} characters`);
    }

    if (typeof type.minLength === "number" && unboxed.length < type.minLength) {
      throw new Error(`this must be at least ${type.minLength} characters`);
    }
  };
};
